import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import PortionCard from "./PortionCard";
import PortionNotFound from "./PortionNotFound";
import { PortionsContext } from "../context/PortionsContext";
import { isDesktop, isTablet } from "react-device-detect";

class PortionSelector extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchSelected: 'dists',
    };
  }

  setSearchSelected(sel) {
    this.setState({
      searchSelected: sel
    });
  }

  render() {
    return (
      <div style={this.props.style}>
        <div className="sugerencias-container">
          <div onClick={() => this.setSearchSelected('dists')} className={`home-sugerencias ${this.state.searchSelected === 'dists' ? 'home-sugerencias-selected' : ''}`}>Ciudades</div>
          <div onClick={() => this.setSearchSelected('devs')} className={`home-sugerencias ${this.state.searchSelected === 'devs' ? 'home-sugerencias-selected' : ''}`}>Urbanizaciones</div>
        </div>
        <div className="home-loteamientos-containerHeight">
          <div className="home-loteamientos-container">
            {this.state.searchSelected === 'devs' ?
              this.context.developmentsSearched.length > 0 ?
                this.context.developmentsSearched.map((portion, index) =>
                  <PortionCard
                    key={portion.id}
                    portion={{
                      title: portion.properties.name,
                      body: portion?.properties?.developments?.features[0]?.properties
                        ?.district?.name || portion?.properties?.district?.name || '',
                      id: portion.id
                    }}
                    setLoteamiento={() => {
                      if (this.props.navigation) {
                        this.props.history.push('/loteamientos/mapa');
                      }

                      this.context.setLoteamiento(portion);
                    }}
                    position={index % 2 === 0 ? 'left' : 'right'} />
                )
                :
                <PortionNotFound type="fracciones" />
              :
              this.context.districtsSearched.length > 0 ?
                this.context.districtsSearched.map((district, index) =>
                  <PortionCard
                    key={district.id}
                    portion={{ title: district.name, body: district.department.name, id: district.id }}
                    setLoteamiento={() => {
                      if (this.props.navigation) {
                        this.props.history.push('/loteamientos/mapa');
                      }
                      this.context.setDistrito(district)
                    }}
                    position={index % 2 === 0 ? 'left' : 'right'} />
                )
                :
                <PortionNotFound type="distritos" />
            }
          </div>
        </div>
      </div>
    );
  }
}

PortionSelector.propTypes = {
  history: PropTypes.object.isRequired,
  style: PropTypes.object,
  navigation: PropTypes.bool.isRequired,
}

PortionSelector.contextType = PortionsContext;

export default PortionSelector;
